import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadSingleUniversity } from "@/redux/rtk/features/CRM/university/universitySlice";
import Loader from "@/components/Loader/Loader";
import UniversityProfile from "./UniversityProfile";

export default function UniversityDetails() {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { university, loading } = useSelector((state) => state.university);

    useEffect(() => {
        if (id) {
            dispatch(loadSingleUniversity(id));
        }
    }, [dispatch, id]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="container mx-auto px-4 py-6">
            <div className="grid grid-cols-1 gap-6">
                <UniversityProfile data={university} loading={loading} />
            </div>
        </div>
    );
}
